import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const FormSubmissionDetailViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
FormSubmissionDetailViewTopBar.displayName = "FormSubmissionDetailViewTopBar"
